import { Settings } from 'luxon'
import { type Writable, get, writable } from 'svelte/store'

export const timezone: Writable<string> = writable('Europe/Prague')

// Configure the time zone
Settings.defaultZone = get(timezone)

export const timezoneList: Writable<string[]> = writable(['Europe/Prague'])
